import React from "react";
import { CreateNewDestinationIcon } from "../common/ProjectIcons";

type AddDestinationCardProps = {
    title: string,
    description: string,
    onClick: () => void,
    dataTestId?: string,
}

// Prominent card-style action button for primary destination actions
// (adding a destination to a connection, creating a new destination)
const AddDestinationCard = ({ title, description, onClick, dataTestId = "AddDestinationCard-button" }: AddDestinationCardProps) => {
    return (
        <button
            type="button"
            data-testid={dataTestId}
            className="w-full max-w-md flex flex-col items-center justify-center gap-3 rounded-lg p-8 border-2 border-dark-green bg-light-green hover:bg-light-green-hover hover:shadow-md cursor-pointer transition-all duration-200"
            onClick={onClick}
        >
            <CreateNewDestinationIcon />
            <span className="text-off-black font-semibold text-lg transition-colors duration-300">{title}</span>
            <span className="text-secondary-gray text-sm text-center transition-colors duration-300">{description}</span>
        </button>
    );
};

export default AddDestinationCard;
